
import { useTranslation } from "react-i18next";

import classes from "./currencyShow.module.css";

const AttendanceDetalis = ({ Attendance }) => {
  const { t } = useTranslation();


  const titles = {
    id: "#",
    name:t("employe"),
    check_in_type:t("check_in_type"),
    check_out_type:t("check_out_type"),
    in_branch:t("in_branch"),
    in_time:t("in_time"),
    late_time:t("late_time"),
    date:t("date"),
    company:t("company"),



  };

  const { id, employe ,check_in_type ,check_out_type ,in_branch ,in_time ,late_time ,date,company } = Attendance;
  return (
    <div className={classes.container}>
      <div className={classes.tableCard}>
        <table className={classes.showCurrency}>
          <tr>
            <th>{titles.id}</th>
            <td>{id}</td>
          </tr>
          <tr>
            <th>{titles.check_in_type}</th>
            <td>{check_in_type}</td>
          </tr>
          <tr>
            <th>{titles.check_out_type}</th>
            <td>{check_out_type}</td>
          </tr>
          <tr>
            <th>{titles.in_branch}</th>
            <td>{in_branch}</td>
          </tr>
          <tr>
            <th>{titles.in_time}</th>
            <td>{in_time}</td>
          </tr>
          <tr>
            <th>{titles.late_time}</th>
            <td>{late_time}</td>
          </tr>
          <tr>
            <th>{titles.date}</th>
            <td>{date}</td>
          </tr>
          <tr>
            <th>{titles.company}</th>
            <td>{company}</td>
          </tr>
         
        </table>
      </div>
    </div>
  );
};

export default AttendanceDetalis;
